import qs from 'qs'
// import request from '@/utils/request'
import {api,apitest} from '../api.request';
// request.defaults.baseURL = "https://yapi.chujiangnet.com/mock/25/";



/**
 * 50款退货频次最高的商品
 * 
 */
function highestReturnFrequencyGoods() {
    // api.get({
    //   url: '/bottom/highestReturnFrequencyGoods',
    //   method: 'get',
    //   data: qs.stringify({})
    // })
    return apitest.get("/bottom/highestReturnFrequencyGoods")
}

//本月20家退货回大仓最多店铺
function mostShopsReturnGoods() {
  // return request({
  //   url: '/bottom/mostShopsReturnGoods',
  //   method: 'get',
  //   data: qs.stringify({})
  // })
  return apitest.get("/bottom/mostShopsReturnGoods")
}

//商品正价销售数 BOTTOM50
function saleAtRegularPrice() {
  // return request({
  //   url: '/bottom/saleAtRegularPrice',
  //   method: 'get',
  //   data: qs.stringify({})
  // })
  return apitest.get("/bottom/saleAtRegularPrice")
}
//本月商品销量 BOTTOM50
function saleRankingListASCGoods() {
  // return request({
  //   url: '/bottom/saleRankingListASCGoods',
  //   method: 'get',
  //   data: qs.stringify({})
  // })
  return apitest.get("/bottom/saleRankingListASCGoods")

}

//本月店铺拉新 BOTTOM20
function storeNewMembers() {
  // return request({
  //   url: '/bottom/storeNewMembers',
  //   method: 'get',
  //   data: qs.stringify({})
  // })
  return apitest.get("/bottom/storeNewMembers")
}

export default {
  highestReturnFrequencyGoods,
  mostShopsReturnGoods,
  saleAtRegularPrice,
  saleRankingListASCGoods,
  storeNewMembers
}